<template>
  <div class="search-box">
    <div
      class="input-group input-group-outline mb-3"
      v-bind:class="{ 'focused is-focused': focused, 'is-filled': searchQuery  }"
    >
      <label class="form-label">{{label}}</label>
      <input
        type="text"
        class="form-control"
        @focus="focused=!focused"
        @blur="clearSearch"
        @input="filterItems"
        
        v-model="searchQuery"
        readonly="readonly"
      />
    </div>
    <ul v-if="searchQuery.length >= 3" class="list-group">
      <li
        class="list-group-item"
        v-for="item in filteredItems"
        :key="item.id"
        @click="setItem(item.id)"
      >{{ item.name }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    label: { type: String, required: false, default: "" },
    items: { type: Array, required: false, default: () => [] }
  },
  mounted() {
    let input = this.$el.firstElementChild.lastElementChild;
    setTimeout(() => {
      input.removeAttribute("readonly");
    }, 500);
    this.filteredItems = this.items;
  },
  data() {
    return {
      focused: false,
      valueDefault: "",
      searchQuery: "",
      filteredItems: []
    };
  },
  methods: {
    filterItems() {
      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.items.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    },
    clearSearch() {
      this.focused = !this.focused;
      const _that = this;
      setTimeout(() => {
          _that.searchQuery = "";
          _that.filteredItems = [];
      }, 1000);
    },
    setItem(id) {
      this.focused = !this.focused;
      this.$emit("handle", id);
    }
  }
};
</script>
<style scoped>
.search-box {
  position: relative;
  float: left;
  width: 100%;
}
.list-group {
  position: absolute;
  float: left;
  left: 0px;
  right: 0px;
  top: 40px;
  height: auto;
  max-height: 300px;
  overflow: auto;
  -webkit-border-bottom-right-radius: .5rem;
  -webkit-border-bottom-left-radius: .5rem;
  -moz-border-radius-bottomright: .5rem;
  -moz-border-radius-bottomleft: .5rem;
  border-bottom-right-radius: .5rem;
  border-bottom-left-radius: .5rem;
-webkit-border-top-left-radius: 0px;
-webkit-border-top-right-radius: 0px;
-moz-border-radius-topleft: 0px;
-moz-border-radius-topright: 0px;
border-top-left-radius: 0px;
border-top-right-radius: 0px;
  border: 2px solid #ddd !important;
  background: none;
  border-top: none;
  list-style: none;
  z-index: 9999;
  border-top-color: transparent !important;
}
.list-group > :last-child{
    -webkit-border-bottom-right-radius: .5rem;
  -webkit-border-bottom-left-radius: .5rem;
  -moz-border-radius-bottomright: .5rem;
  -moz-border-radius-bottomleft: .5rem;
  border-bottom-right-radius: .5rem;
  border-bottom-left-radius: .5rem;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background: #f8f9fa;
  border-top: 1px solid #FFF;
  color:#8687a4
}
.list-group-item:hover {
  background: rgb(255, 255, 255) !important;
  color: #3b5de7 !important;
  cursor: pointer;
}
</style>